module.exports = __webpack_public_path__ + "img/river_painter3.34c57ef2.png";